/**
 * Map CS Admin company_type_code (E&G, LS, ADGM, …) to org-chart visual categories.
 */

export function resolveOrgChartVisualType({ companyTypeCode, isRootParent, stake } = {}) {
  const code = String(companyTypeCode || '').trim().toUpperCase();

  if (isRootParent || code === 'E&G' || code === 'HOLDING' || code === 'PARENT') {
    return 'holding';
  }
  if (code === 'JV' || code === 'JOINT_VENTURE' || code === 'JOINT-VENTURE') {
    return 'joint-venture';
  }
  if (code === 'ASSOCIATE') {
    return 'associate';
  }

  const s = Number(stake);
  if (Number.isFinite(s) && s > 0) {
    if (s >= 75) return 'subsidiary';
    if (s >= 50) return 'joint-venture';
    return 'associate';
  }

  return 'subsidiary';
}

/** Solid fills export reliably to PNG (CSS gradients often render grey in html-to-image). */
export function getCompanyNodeStyles(chartType) {
  switch (chartType) {
    case 'holding':
      return { bg: '#991b1b', border: '#b91c1c', badge: '#fecaca' };
    case 'subsidiary':
      return { bg: '#dc2626', border: '#ef4444', badge: '#fca5a5' };
    case 'joint-venture':
      return { bg: '#ef4444', border: '#f87171', badge: '#fecaca' };
    case 'associate':
      return { bg: '#f87171', border: '#fecaca', badge: '#fee2e2' };
    default:
      return { bg: '#dc2626', border: '#ef4444', badge: '#fca5a5' };
  }
}

export function getOwnershipEdgeStyle(stake) {
  const s = Number(stake) || 0;
  if (s >= 75) {
    return { stroke: '#b91c1c', strokeWidth: 2, color: '#b91c1c' };
  }
  if (s >= 50) {
    return { stroke: '#dc2626', strokeWidth: 2, color: '#dc2626' };
  }
  return { stroke: '#f87171', strokeWidth: 2, color: '#f87171' };
}

export function minimapColorForChartType(chartType) {
  switch (chartType) {
    case 'holding': return '#7f1d1d';
    case 'subsidiary': return '#b91c1c';
    case 'joint-venture': return '#dc2626';
    case 'associate': return '#f87171';
    default: return '#b91c1c';
  }
}

/** Elements excluded from PNG/SVG export (controls overlay the chart). */
export function shouldIncludeInChartExport(node) {
  if (!node?.classList) return true;
  const skip = [
    'react-flow__minimap',
    'react-flow__controls',
    'react-flow__panel',
  ];
  return !skip.some((cls) => node.classList.contains(cls));
}
